import React, { useMemo } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { IDriver } from '@/modules/driver/model/driver';
import { CarCell } from '@/shared/view/CarCell';
import { DescriptionList, RowWrapper } from '@/shared/view/DescriptionList';
import { Icon } from '@src-common/view/components/Icon';

import s from './PersonalInfo.module.css';

interface IProps {
  driver: IDriver;
}

const CurrentVehicle = ({ driver }: IProps) => {
  const intl = useIntl();

  const titles = useMemo(
    (): Array<['car', React.ReactNode, RowWrapper?]> => [
      [
        'car',
        driver.carId ? (
          <CarCell key={driver.carId} carId={driver.carId} />
        ) : (
          intl.formatMessage({
            defaultMessage: 'Select vehicle',
            id: 'y2at3e',
            description: 'Driver screen: Unassigned vehicle label',
          })
        ),
        ({ children }) => (
          <Link
            to={
              driver.carId ? `/vehicles/${driver.carId}` : `/chauffeurs/${driver.id}/edit-vehicle`
            }
            className={s.link}
          >
            {children}
          </Link>
        ),
      ],
    ],
    [driver.carId, driver.id, intl],
  );

  const values = {
    car: () => <Icon icon={'chevron-to-end'} className={s.linkIcon} />,
  };

  return (
    <DescriptionList
      title={intl.formatMessage({
        defaultMessage: 'Current vehicle',
        id: 'XAa3Zy',
        description: 'Driver screen: Current vehicle section heading',
      })}
      values={values}
      titles={titles}
      action={
        driver.carId ? (
          <Link to={`/chauffeurs/${driver.id}/edit-vehicle`} className={s.edit}>
            <FormattedMessage
              defaultMessage="Change"
              id="gRATpQ"
              description="Driver screen: Current vehicle change button"
            />
          </Link>
        ) : null
      }
    />
  );
};

export { CurrentVehicle };
